"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREVIEW_TYPES = void 0;
var PREVIEW_TYPES;
(function (PREVIEW_TYPES) {
    PREVIEW_TYPES["FIRST_20_SEC"] = "first-20-sec";
    PREVIEW_TYPES["TRAILER"] = "trailer";
    PREVIEW_TYPES["AUTOGENERATED"] = "autogenerated";
    PREVIEW_TYPES["NONE"] = "none";
})(PREVIEW_TYPES = exports.PREVIEW_TYPES || (exports.PREVIEW_TYPES = {}));
//# sourceMappingURL=preview-types.js.map